import { useState, useRef } from 'react';
import {
    Button,
    Popper,
    Box,
    Paper,
    Fade,
    Skeleton,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { KeyboardArrowDown } from '@mui/icons-material';
import PlanDetails from './PlanDetails';
import { useCreditsAndPlans } from './context';

export default function PlanPopover() {
    const { t } = useTranslation();

    const { planName, planNameLoading, isThirdPartyMerchant } = useCreditsAndPlans()


    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const popperRef = useRef(null);

    const timerRef = useRef(null);

    const handleMouseEnter = () => {
        clearTimeout(timerRef.current);
        timerRef.current = null
        setOpen(true);
    };

    const handleMouseLeave = () => {
        timerRef.current = setTimeout(() => {
            setOpen(false);
        }, 200);
    };

    return (
        <div>
            <Button
                ref={anchorRef}
                color="white"
                variant="outlined"
                onMouseEnter={() => {
                    if (isThirdPartyMerchant) return
                    handleMouseEnter();
                }}
                onMouseLeave={() => {
                    if (isThirdPartyMerchant) return
                    handleMouseLeave();
                }}
                sx={{
                    textTransform: 'none',
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                    }
                }}
                endIcon={!isThirdPartyMerchant ? <KeyboardArrowDown color='white' /> : undefined}
            >
                {
                    planNameLoading ?
                        <Skeleton
                            variant="text"
                            width={90}
                            height={20}
                        />
                        :
                        planName
                }
            </Button>

            <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement="bottom"
                transition
                disablePortal
                sx={{ zIndex: 1300 }}
            >
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper
                            ref={popperRef}
                            elevation={3}
                            onMouseEnter={() => {
                                handleMouseEnter();
                            }}
                            onMouseLeave={() => {
                                handleMouseLeave();
                            }}
                            sx={{ p: 2, mt: 2 }}
                        >
                            <Box width={300}>
                                <PlanDetails />
                            </Box>
                        </Paper>
                    </Fade>
                )}
            </Popper>
        </div>
    );
}